export default __webpack_public_path__ + "static/media/video_bg.3b7ad98c.jpg";